import RichText, { isDeltaEmpty } from './RichText';
// eslint-disable-next-line import/no-cycle
import { H1, H2, H3 } from '../oc-h';

const isMainHeadingEmpty = mainHeading => {
  if (!mainHeading) return true;
  if (typeof mainHeading === 'string') return mainHeading.trim() === '';
  if (typeof mainHeading === 'object' && Object.keys(mainHeading).length === 0) return true;
  if (typeof mainHeading === 'object' && mainHeading.ops) {
    return isDeltaEmpty(mainHeading);
  }
  return false;
};

/* eslint-disable react/prop-types */
const Heading = ({ prehead, mainHeading, headingClass = '', headingFont, headingTag = 'h2' }) => {
  const tags = { h1: H1, h2: H2, h3: H3 };
  const TagComponent = tags[headingTag] || H2;
  const headingClasses = [headingClass].filter(Boolean);

  if ((!prehead || prehead.trim() === '') && isMainHeadingEmpty(mainHeading)) return null;

  return (
    <TagComponent className={headingClasses.join(' ')} prehead={prehead} font={headingFont} key={mainHeading}>
      <RichText content={mainHeading} inline />
    </TagComponent>
  );
};
/* eslint-enable react/prop-types */

export default Heading;
